
import {mapActions, mapState} from "vuex";
import addBackground from "@/components/addBackground.vue";
import {Toast} from "vant";

export default {
  components: {addBackground},
  props: {
    pageBg: {
      type: String
    },
  },
  data(){
    return{
      isBack:false,
      bgImg:''
    }
  },
  mounted() {
    if(this.sceneList.scBackImg){
      const isHttpUrl =  this.sceneList.scBackImg.startsWith("http")
      if (isHttpUrl) {
        this.bgImg=this.sceneList.scBackImg
      }else {
        this.bgImg=this.upFileUrl + this.sceneList.scBackImg
      }

    }
  },
  computed: {
    ...mapState({
      sceneList: state => state.sceneList,
    })
  },
  methods: {
    ...mapActions(['addBackground']),
    fullscreen() {
      this.$emit('fullscreen')
    },
    addbackground() {
      if(this.bgImg !='' || this.pageBg !=''){
        Toast(this.$t('append_field.oneImage'))
        return
      }
      this.isBack = true
    },
    dele() {
      this.$emit('ondele')
      this.bgImg=''
    },
    setBackImage(data) {
      this.isBack = false
      this.addBackground(data)
      const isHttpUrl =  data.url.startsWith("http")
      if (isHttpUrl) {
        this.bgImg=data.url
      }else {
      this.bgImg=this.upFileUrl + data.url
      }
    },
    close() {
      this.isBack = false
    },
    errImg(event) {
      event.target.src = '/static/images/icon_loader_failed_braseas.png'; // 设置错误图片
    },
  },
}
